import { render, staticRenderFns } from "./ProcurementView.vue?vue&type=template&id=63778655&scoped=true"
import script from "./ProcurementView.vue?vue&type=script&lang=js"
export * from "./ProcurementView.vue?vue&type=script&lang=js"
import style0 from "./ProcurementView.vue?vue&type=style&index=0&id=63778655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63778655",
  null
  
)

export default component.exports